import { callApi } from './api';

import { User, UserRequest } from '@/types/user';

export const createUser = async (user: UserRequest) => {
  if (user.role === 'p_admin') {
    user.children = user.children?.filter(
      (child) => child.last_name !== '' || child.first_name !== ''
    );
  }
  const { status, result } = await callApi<User>(
    'users/user',
    'POST',
    undefined,
    user,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
